module.exports = __webpack_public_path__ + "img/about_banner01.dd5d377d.png";